import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    params: {
        page: 1,
        per_page: 999,
    }
}

const mutations = {
    changeBannerPage(state, val) {
        state.params = val
        // state.params.shopPath = val.shopPath
    }

}

export default {
    state,
    mutations
}